export { NewsFeatured } from './NewsFeatured';
